module.exports = __webpack_public_path__ + "static/media/rev-left-img.791e8f67.png";